import styled, { css } from 'styled-components'
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 16px;
  z-index: 1;
  max-height: 92vh;
  overflow-y: auto;
  width: 92vw;
  max-width: 1480px;
  box-sizing: border-box;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  padding-bottom: 24px;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 3vw);
  margin-top: 24px;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #111827;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 36px;
  height: 36px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f4f6;
  }
`

export const CloseImg = styled.img`
  width: 14px;
  height: 14px;
`

export const ProgressBarDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  .active {
    background-color: #0090d3;
  }
`

export const ProgressBarCircle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #c4c4c4;
`

export const ProgressBarLine = styled.div`
  width: 20vw;
  max-width: 240px;
  height: 4px;
  background-color: #c4c4c4;
`

export const Phrase = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
  margin-top: 16px;
  margin-bottom: 0;
  line-height: 20px;
  color: #6b7280;
  padding: 0;
`

export const SwitchesDiv = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
  gap: 28px;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
  flex-wrap: wrap;
`

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchLabel = styled.label`
  font-weight: 700;
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  color: #374151;
`

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  margin-top: 8px;
  width: 60px;
  height: 34px;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    background-color: #2196f3;
    border: 0;
    padding: 2px;
  }

  :focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  :checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  border: #696969 2px solid;

  :before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 5.5px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const MappingArea = styled.div`
  background-color: #ffffff;
  margin: 20px 1.5vw 0 1.5vw;
  width: calc(100% - 3vw);
  box-sizing: border-box;
`

export const RowsDiv = styled.div`
  display: block;
  width: 100%;
  overflow-x: auto;
  padding: 14px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #999999;
  }
`

export const RowDiv = styled.div`
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 2px 0;
  width: max-content;
  min-width: max-content;

  &:not(:last-child) {
    margin-bottom: 6px;
  }
`

export const RowText = styled.div`
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: #f9fafb;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  color: #374151;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  flex: 0 0 150px;
  flex-shrink: 0;
  padding-right: 12px;
  display: flex;
  align-items: center;
  line-height: 1.3;
`

export const RowFieldDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`

export const PreviewText = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-top: 24px;
  margin-bottom: 12px;
`

export const PreviewContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
  margin-top: 12px;

  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }
`

export const Preview = styled.table`
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  width: max-content;
  min-width: 100%;
  text-align: left;
`

export const TableBody = styled.tbody`
`

export const HeaderRow = styled.tr`
  background-color: #f9fafb;
`

export const HeaderCell = styled.th`
  background-color: #f9fafb;
  color: #374151;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  vertical-align: middle;
  padding: 10px 16px;
  white-space: nowrap;
  border-bottom: 2px solid #e5e7eb;
  border-right: 1px solid #f3f4f6;

  &:last-child {
    border-right: none;
  }
`

export const ItemRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9fafb;
  }

  &:hover {
    background-color: #f0f9ff;
  }
`

export const ItemCell = styled.td`
  color: #4b5563;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  vertical-align: middle;
  padding: 8px 16px;
  white-space: nowrap;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #f3f4f6;
  border-right: 1px solid #f3f4f6;

  &:last-child {
    border-right: none;
  }
`

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 3vw);
  margin-top: 24px;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
`

export const CancelButton = styled.button`
  min-width: 110px;
  height: 44px;
  background-color: transparent;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
  padding: 0 16px;
  border-radius: 22px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const PreviousButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 110px;
  height: 44px;
  background-color: #fff;
  color: #0090d3;
  border: solid #0090d3 1px;
  border-radius: 22px;
  cursor: pointer;
  padding: 0 16px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const PreviousButtonImage = styled.img`
  width: 14px;
  height: 14px;
`

export const PreviousButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`

export const NextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 130px;
  height: 44px;
  background-color: #0090d3;
  color: #fff;
  border-radius: 22px;
  cursor: pointer;
  padding: 0 16px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #007bb5;
  }
`

export const NextButtonImage = styled.img`
  width: 14px;
  height: 14px;
`

export const NextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`

export const DisabledNextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 130px;
  height: 44px;
  background-color: #ebebeb;
  color: #c4c4c4;
  border-radius: 22px;
  cursor: not-allowed;
  padding: 0 16px;
`

export const DisabledNextButtonImage = styled.img`
  width: 14px;
  height: 14px;
`

export const DisabledNextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`

export const MappingSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
`

export const MappingSection = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 20px;
  background-color: #ffffff;
  width: 100%;
  box-sizing: border-box;
`

export const MappingSectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 14px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  &.matched {
    color: #16a34a;
  }

  &.unmatched-spreadsheet {
    color: #d97706;
  }

  &.unmatched-stock {
    color: #2563eb;
  }
`

export const MappingSectionCount = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: #f3f4f6;
  color: #4b5563;
`

export const MappingSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MappingRowsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0;
`

export const MappingColumnItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 150px;
`

export const MappingSelect = styled.select.attrs({
  className: 'custom-select',
})`
  background-color: #ebebeb !important;
  color: #374151 !important;
  height: 38px !important;
  min-width: 80px;
  flex-shrink: 0;
  padding-left: 14px !important;
  padding-right: 30px !important;
  border-radius: 19px !important;
  border: 1px solid #d1d5db !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 10px center !important;
  background-size: 14px 14px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  cursor: pointer !important;
  box-sizing: border-box !important;
  display: inline-block !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;

  &:hover {
    border-color: #9ca3af !important;
  }

  &:focus {
    outline: none !important;
    border-color: #0090d3 !important;
    box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.2) !important;
  }

  option {
    font-family: 'Inter', sans-serif !important;
    font-size: 12px !important;
    color: #111827 !important;
    background-color: #ffffff !important;
    padding: 6px !important;
  }
`

export const MappingRowLabel = styled.p`
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  color: #777777;
  margin: 0;
  padding: 8px 0;
`

export const EmptyMessage = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #999;
  font-style: italic;
  margin: 0;
  padding: 10px 0;
`